import { Flex } from '@cognite/cogs.js-v10';
import { UnleashKeys } from '@infield/constants/unleash-keys';
import type { RootLocationFeatureToggles } from '@infield/features/app-config';
import { LOCIZE_NAMESPACES, useTranslation } from '@infield/features/i18n';
import type { FC } from 'react';

import { useSidebarContentContext } from './sidebar-content.context';
import { SidebarItem } from './sidebar-item';
import { getGeneralNavigationItems } from './utils';

export type SidebarContentProps = {
  rootLocationFeatureToggles?:
    | RootLocationFeatureToggles
    | Record<string, boolean>;
  isOnline: boolean;
  currentAppLocation: string;
  onNavigationItemClick: (navigateTo: string) => void;
};

export const SidebarContent: FC<SidebarContentProps> = ({
  rootLocationFeatureToggles,
  isOnline,
  currentAppLocation,
  onNavigationItemClick,
}) => {
  const { useFlag } = useSidebarContentContext();
  const { t } = useTranslation(LOCIZE_NAMESPACES.sidebar);
  const { isEnabled: isTemplatesOnMobileEnabled } = useFlag(
    UnleashKeys.mobile_template,
    {
      forceRerender: true,
      fallback: false,
    }
  );

  const generalNavigationItems = getGeneralNavigationItems(
    t,
    rootLocationFeatureToggles,
    isTemplatesOnMobileEnabled
  );

  const isToggled = (navigationItemPath: string) =>
    currentAppLocation.includes(navigationItemPath);

  return (
    <Flex direction="column" gap={4}>
      {generalNavigationItems.map((item) => (
        <SidebarItem
          key={item.key}
          toggled={isToggled(item.to)}
          icon={item.icon}
          disabled={!isOnline}
          onClick={() => onNavigationItemClick(item.to)}
          data-testid="sidebar-item"
        >
          {item.name}
        </SidebarItem>
      ))}
    </Flex>
  );
};
